/*
 * https://github.com/morethanwords/tweb
 * Copyright (C) 2019-2021 Eduard Kuzmenko
 * https://github.com/morethanwords/tweb/blob/master/LICENSE
 */

// * Electron fix: sometimes browser globals are shadowed or missing in production bundle
// * Aggressive Service Worker Kill-Switch for Electron/file: protocol
if(typeof window !== 'undefined' && window.location.protocol === 'file:' && navigator.serviceWorker) {
  // If we have a controller, it means a Service Worker is actively intercepting requests.
  // This is fatal for file:// protocol. We must unregister and reload.
  const killSW = () => {
    navigator.serviceWorker.getRegistrations().then(regs => {
      if(regs.length > 0) {
        console.warn('[KILL-SW] Rogue Service Workers detected. Purging...', regs.length);
        Promise.all(regs.map(reg => reg.unregister())).then(() => {
          console.warn('[KILL-SW] Purge complete. Reloading page...');
          window.location.reload();
        });
      }
    });
  };

  if(navigator.serviceWorker.controller) {
    killSW();
  } else {
    // Check registrations even if no controller yet
    killSW();
  }
}


if(typeof Response === 'undefined') (globalThis as any).Response = (typeof self !== 'undefined' && (self as any).Response) || class {};
if(typeof Request === 'undefined') (globalThis as any).Request = (typeof self !== 'undefined' && (self as any).Request) || class {};
if(typeof Headers === 'undefined') (globalThis as any).Headers = (typeof self !== 'undefined' && (self as any).Headers) || class {};


import bufferConcats from '@helpers/bytes/bufferConcats';

Uint8Array.prototype.concat = function(...args: Array<Uint8Array | ArrayBuffer | number[]>) {
  return bufferConcats(this, ...args);
};

/* Uint8Array.prototype.toString = function() {
  return String.fromCharCode.apply(null, [...this]);
}; */

Uint8Array.prototype.toJSON = function() {
  return [...this];
  // return {type: 'bytes', value: [...this]};
};

Promise.prototype.finally = Promise.prototype.finally || function<T>(this: Promise<T>, fn: () => any) {
  const onFinally = (callback: typeof fn) => Promise.resolve(fn()).then(callback);
  return this.then(
    (result) => onFinally(() => result),
    (reason) => onFinally(() => Promise.reject(reason))
  );
};

declare global {
  interface Uint8Array {
    concat: (...args: Array<Uint8Array | ArrayBuffer | number[]>) => Uint8Array,
    // toString: () => string,
    toJSON: () => number[],
    // toJSON: () => {type: 'bytes', value: number[]},
  }

  interface Promise<T> {
    finally: (onfinally?: () => void) => Promise<T>;
  }
}
